import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import pageStatusReducer from './pageStatusSlice'
import userSessionReducer from './userSessionSlice'
import authReducer from './auth/slice'
import selectGeolocationReducer from './geoLocation/geoLocationSlice'
import imageReducer from './image/imageSlice'
import teamMemberReducer from './teamMember/slice'
import manageTasksReducer from './task/manageTasks/slice'
import taskReducer from './task/slice'
import invitedTeamMemberPerEventReducer from './reports/event/invitedTeamMemberPerEvent/slice'
import assignedTeamMemberPerTaskReducer from './reports/task/assignedTeamMemberPerTask/slice'
import teamMemberEventsReducer from './event/teamMemberEvents/slice'
import teamMemberTasksReducer from './task/teamMemberTasks/slice'
import manageEventsReducer from './event/manageEvents/slice'
import eventDetailsReportReducer from './reports/event/slice'
import taskDetailsReportReducer from './reports/task/slice'
import feedbackReducer from './feedback/slice'

const rootReducer = {
  pageStatus: pageStatusReducer,
  userSession: userSessionReducer,
  auth: authReducer,
  geolocation: selectGeolocationReducer,
  teamMember: teamMemberReducer,
  image: imageReducer,
  manageTasks: manageTasksReducer,
  task: taskReducer,
  invitedTeamMemberPerEvent: invitedTeamMemberPerEventReducer,
  assignedTeamMemberPerTask: assignedTeamMemberPerTaskReducer,
  teamMemberEvents: teamMemberEventsReducer,
  teamMemberTasks: teamMemberTasksReducer,
  manageEvents: manageEventsReducer,
  eventDetailsReport: eventDetailsReportReducer,
  taskDetailsReport: taskDetailsReportReducer,
  feedback: feedbackReducer,
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
})

// Types for dispatch and state
export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
